import { defineStore } from 'pinia'

type LayoutFormat = 'card' | 'plain'
type LayoutStore = {
  format: LayoutFormat
  isSidebarOpened: boolean
}

const useLayoutStore = defineStore({
  id: 'layout',

  state: (): LayoutStore => ({
    format: 'card',
    isSidebarOpened: false,
  }),

  actions: {
    setFormat(format: LayoutFormat) {
      this.format = format
    },
    closeSidebar() {
      this.isSidebarOpened = false
    }
  },
})

export default useLayoutStore
